module.exports = __webpack_public_path__ + "img/currency-guide-2.9ed6891f.png";